module.exports = __webpack_public_path__ + "dash_20_app_assets/img/ct.de1a0239.png";